module.exports = __webpack_public_path__ + "static/media/stanza_transparent_red.a3027819.png";